import React, { useEffect, useState } from 'react';

// Zdieľaný vejár (fan) pre mobilný topbar — vizuál/animácie žijú v MobileTopbar.css
// (triedy mt-fan*). Používa ho produkčný MobileTopbar aj app2 (V2MobileTopbar),
// aby bol mobilný panel 1:1 a nedriftoval. Čistý presentational: dáta + onPick
// dodá volajúci.
export const FAN_ICONS = {
  search:  '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',
  doc:     '<path d="M7 3h10v18H7zM10 8h7M10 12h7M10 16h5"/>',
  receipt: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h4"/>',
  folder:  '<path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>',
  users:   '<circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M3 19c0-3 3-5 6-5s6 2 6 5M15 19c0-2 1-3.5 3-3.5s3 1.5 3 3.5"/>',
  archive: '<rect x="4" y="4" width="16" height="5" rx="1"/><path d="M5 9v11h14V9M9 13h6"/>',
  gear:    '<circle cx="12" cy="12" r="3.2"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>',
  qr:      '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M21 17v4M17 21h4"/>',
  camera:  '<path d="M3 8l2-3h14l2 3v11H3z"/><circle cx="12" cy="13" r="3.5"/>',
  services: '<path d="M14 8a3 3 0 1 0-3 3l-7 7v3h3l7-7a3 3 0 0 0 3-3"/>',
  euro:    '<path d="M18 6a7 7 0 1 0 0 12M3 10h10M3 14h9"/>',
  box:     '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>',
  gauge:   '<path d="M12 13l4-4M4 18a8 8 0 1 1 16 0"/>',
  clock:   '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
  car:     '<path d="M5 11l1.6-4.2A2 2 0 0 1 8.5 5.5h7a2 2 0 0 1 1.9 1.3L19 11"/><path d="M4 11h16a1 1 0 0 1 1 1v4H3v-4a1 1 0 0 1 1-1z"/><circle cx="7.5" cy="16.5" r="1.3"/><circle cx="16.5" cy="16.5" r="1.3"/>',
};

// Vertical dropdown layout (Daniel feedback 2026-05-17 — fan replaced with column).
export function fanLayout(n) {
  const SPACING = 62;
  const HEAD = 56; // gap medzi anchor button-om a prvou položkou
  const ICON = 46;
  const FONT = 17;
  const pts = [];
  for (let i = 0; i < n; i++) pts.push({ x: 0, y: HEAD + i * SPACING });
  return { pts, ICON, FONT };
}

export default function MobileFan({ items, anchorRef, active, dir, onPick }) {
  const [origin, setOrigin] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!active) return;
    const el = anchorRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setOrigin({ x: r.left + r.width / 2, y: r.top + r.height / 2 });
  }, [active, anchorRef]);

  const layout = fanLayout(items.length);
  const mirror = dir === 'l' ? -1 : 1;

  return (
    <div className={`mt-fan ${active ? 'is-active' : ''}`}
      style={{ left: origin.x, top: origin.y }}
    >
      {items.map((it, i) => {
        const p = layout.pts[i];
        return (
          <button
            key={it.id}
            type="button"
            className={`mt-fan-item dir-${dir} ${it.color}`}
            style={{
              '--isz': `${layout.ICON}px`,
              '--x':   `${(mirror * p.x).toFixed(1)}px`,
              '--y':   `${p.y.toFixed(1)}px`,
              '--in-d':  `${i * 36}ms`,
              '--out-d': `${(items.length - 1 - i) * 36}ms`,
            }}
            onClick={(e) => { e.stopPropagation(); onPick(it); }}
            aria-label={it.label}
          >
            <span className="fi-circle">
              <svg viewBox="0 0 24 24" dangerouslySetInnerHTML={{ __html: FAN_ICONS[it.icon] || '' }} />
            </span>
            <span className="fi-lab" style={{ fontSize: `${layout.FONT.toFixed(1)}px` }}>
              {it.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
